// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b3f5fadb","799":"2d53dd2c"}[chunkId] + ".chunk.js";
};